import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { MakeOutBoundCallConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';

export class MakeOutBoundCallNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: MakeOutBoundCallConfig) {
    super(id, NodeType.MakeOutBoundCall, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['agentId'] == '';
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig() {
    (this.config as MakeOutBoundCallConfig).agentId = '';
    (this.config as MakeOutBoundCallConfig).isRetryFailCalls = false;
    (this.config as MakeOutBoundCallConfig).isContactAll = false;
    (this.config as MakeOutBoundCallConfig).retryTimeRanges = [];
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    const config = this.config as MakeOutBoundCallConfig;

    if (!config.agentId || config.agentId.trim() === '') {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'Llamada saliente',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    if (config.isRetryFailCalls) {
      const selectedRanges = config.retryTimeRanges!.filter((r) => r.selected);

      for (let i = 0; i < selectedRanges.length; i++) {
        const current = selectedRanges[i];

        if (!current.from || !current.to) continue;

        if (current.from >= current.to) {
          errors.push({
            nodeId: this.id,
            errorMessage: getValidationErrorMessage(ValidationError.INVALID_TIME_ORDER, {
              label: current.label,
            }),
          });
          continue;
        }

        for (let j = 0; j < selectedRanges.length; j++) {
          if (i === j) continue;
          const compare = selectedRanges[j];

          if (!compare.from || !compare.to) continue;

          const overlap = current.from < compare.to && current.to > compare.from;

          if (overlap) {
            errors.push({
              nodeId: this.id,
              errorMessage: getValidationErrorMessage(ValidationError.OVERLAPPING_RETRY_RANGE, {
                labelA: current.label,
                labelB: compare.label,
              }),
            });
            break;
          }
        }
      }
    }

    return errors;
  }
}
